<template>
  <div class="contain">
    <el-collapse-transition>
      <!-- 历史记录 展开状态，完整列表展示 -->
      <div class="extend" v-if="!showMap">
        <div class="title">{{ $t('History') }}</div>
        <!-- 标签页 -->
        <div class="main view-info">
          <!-- 查询条件 -->
          <el-form :inline="true" label-width="40px">
            <!-- 设备状态详情页签 只有一个结束时间查询条件 -->
            <el-form-item v-if="activeName === 'deviceDetail'" class="deviceDetail-class">
              <el-date-picker
                v-model="listDataQuery.deviceDetail.logTimestampEnd"
                type="datetime"
                placeholder="选择时间"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :clearable="false"
                @change="pageChange"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
            <!-- 其它页签 时间范围查询条件 -->
            <el-form-item
              v-if="activeName !== 'deviceDetail' && activeName !== 'jlsDeviceDetail'"
              class="deviceDetail1-class"
            >
              <el-date-picker
                v-model="query.logTimestampBegin"
                :placeholder="$t('pleaseSelecDate')"
                value-format="yyyy-MM-dd"
                :clearable="false"
                @change="pageChange"
                size="small"
              >
              </el-date-picker>
              <span class="black">~</span>
              <el-date-picker
                v-model="query.logTimestampEnd"
                :placeholder="$t('pleaseSelecDate')"
                value-format="yyyy-MM-dd"
                :clearable="false"
                @change="pageChange"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col :span="24">
              <el-tabs v-model="activeName" type="card" @tab-click="pageChange">
                <!-- 图片 页签 -->
                <el-tab-pane
                  :label="$t('pictureS')"
                  name="photo"
                  v-if="
                    mediums.includes(1) &&
                      (userBingDeviceType.includes(1) ||
                        userBingDeviceType.includes(2) ||
                        userBingDeviceType.includes(3))
                  "
                >
                  <div v-if="imgShow" class="preview important-img">
                    <div class="img-title">
                      <i
                        class="back-icon"
                        :class="isDefaultTheme ? 'back-light' : 'back-dark'"
                        @click="imgShow = false"
                      ></i>
                      <!-- <div class="name" style="display: inline-block;">
                        <span>
                          {{ previewMiddleImg.name }}
                        </span>
                        <span class="fz12 time">
                          {{ previewMiddleImg.time }}
                        </span>
                      </div> -->
                    </div>
                    <div class="img-preview tags-list" :style="inenerHeight > 1400 ? 'width: 60%' : 'width: 100%'">
                      <el-image :src="previewMiddleImg.image" :preview-src-list="previewImgList"> </el-image>
                    </div>
                  </div>
                  <ul v-else>
                    <li v-for="(d, index) in listData.photo.list" :key="index">
                      <div class="box">
                        <el-image
                          :src="d.mediaUrl"
                          :title="d.location"
                          class="pic"
                          :lazy="true"
                          @click="previewImgClick(d, index, listData.photo.list)"
                          @error="srcerr(d.mediaUrl, index)"
                        >
                        </el-image>
                        <img
                          class="important-star"
                          src="@/icon/new-command/history/importStar.png"
                          alt=""
                          v-if="d.importantFlag"
                        />
                      </div>
                      <div class="pic_contrl">
                        <div class="flex_just_between lh20">
                          <h5 class="video-time-pic">
                            <span>{{ d.logTimestamp }}</span>
                          </h5>
                          <div class="flex_just_align_center">
                            <div
                              class="pic-icon"
                              :class="[d.importantFlag ? 'setNormalImp-icon' : 'setPicImp-icon']"
                              @click="_setImpImg(d.logTimestamp, d.userId, !d.importantFlag)"
                              :title="[
                                d.importantFlag
                                  ? $t('SetAsNormal') + $t('pictureS')
                                  : $t('SetAsImportant') + $t('pictureS'),
                              ]"
                            ></div>
                            <div
                              class="download-icon pic-icon"
                              @click="downloadImg(d.path, d.name, d.mediaUrl, null)"
                              :title="$t('download')"
                            ></div>
                            <div
                              v-has="'sys:new:command:media:delete'"
                              class="download-icon-delete pic-icon"
                              @click="_mediasDelete(d.logTimestamp, d.type, d.userId)"
                              :title="$t('delete')"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-tab-pane>
                <!-- 视频/重要视频 页签 -->
                <el-tab-pane
                  :label="$t('videoS')"
                  name="video"
                  v-if="
                    mediums.includes(2) &&
                      (userBingDeviceType.includes(1) ||
                        userBingDeviceType.includes(2) ||
                        userBingDeviceType.includes(3))
                  "
                >
                  <div class="exVideo" :style="inenerHeight > 1300 ? 'width: 50%' : 'width: 100%'" v-if="videoShow">
                    <HistoryVideo
                      :videoSrcArr="playVideoData"
                      :index.sync="index"
                      :showBack="true"
                      :videoShow.sync="videoShow"
                      @searchList="searchList"
                      :userData="historyData"
                      :allowDrag.sync="allowDrag"
                      :external="true"
                    >
                    </HistoryVideo>
                  </div>
                  <template v-if="!videoShow">
                    <ul>
                      <li v-for="(d, index) in listData['video'].list" :key="index">
                        <div class="box">
                          <div v-if="d.Played" class="played">{{ $t('Played') }}</div>
                          <!-- 已删除 -->
                          <div class="delete" v-if="d.status === 1">
                            <img class="upper" src="@/icon/monitor/delete.png" />
                            <h5 class="upper-text">{{ $t('Deleted') }}</h5>
                          </div>
                          <!-- 未上传 -->
                          <div v-else-if="!d.uploadFlag">
                            <img class="upper" src="@/icon/monitor/notUploaded.png" />
                            <h5 class="upper-text">{{ $t('NotUploaded') }}</h5>
                          </div>
                          <!-- 正常 -->
                          <el-image
                            v-else
                            :src="
                              d.preMediaUrl === null
                                ? require(theme === 'default'
                                    ? '@/icon/monitor/coverPlaceLight.png'
                                    : '@/icon/monitor/coverPlaceDark.png')
                                : d.preMediaUrl
                            "
                            @click="playVideo(index)"
                            class="pic"
                            :lazy="true"
                            @error="srcerrVideo(d.preMediaUrl, index)"
                          >
                            <div slot="placeholder" class="image-slot">
                              <img class="place-img" :src="d.preMediaUrl" />
                            </div>
                          </el-image>
                          <img
                            class="important-star"
                            src="@/icon/new-command/history/importStar.png"
                            alt=""
                            v-if="d.importantFlag"
                          />
                        </div>
                        <div class="pic_contrl">
                          <div class="flex_just_between lh20">
                            <h5 class="video-time-pic">
                              <span>{{ $t('startS') }}：{{ d.logTimestamp }}</span>
                              <span v-if="d.endTimestamp">{{ $t('endS') }}：{{ d.endTimestamp }}</span>
                            </h5>
                            <div class="flex_just_align_center">
                              <div
                                class="pic-icon"
                                :class="[d.importantFlag ? 'setNormalImp-icon' : 'setPicImp-icon']"
                                @click="_setImpVideo(d.logTimestamp, d.userId, !d.importantFlag)"
                                v-if="d.status != 1"
                                :title="[
                                  d.importantFlag
                                    ? $t('SetAsNormal') + $t('videoS')
                                    : $t('SetAsImportant') + $t('videoS'),
                                ]"
                              ></div>
                              <div
                                class="download-icon pic-icon"
                                @click="downloadImg(d.path, d.name, d.mediaUrl, d)"
                                :title="$t('download')"
                                v-if="d.uploadFlag && d.status != 1"
                              ></div>
                              <div
                                v-has="'sys:new:command:media:delete'"
                                class="download-icon-delete pic-icon"
                                @click="_mediasDelete(d.logTimestamp, d.type, d.userId)"
                                :title="$t('delete')"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <img
                          v-if="d.status === 0 && d.uploadFlag"
                          @click="playVideo(index)"
                          class="center"
                          src="@/icon/monitor/videoPlay.png"
                        />
                      </li>
                    </ul>
                  </template>
                </el-tab-pane>
                <!-- 轨迹 页签 -->
                <el-tab-pane
                  :label="$t('trajectory')"
                  name="trail"
                  class="trail-tab"
                  v-if="
                    mediums.includes(3) &&
                      (userBingDeviceType.includes(1) ||
                        userBingDeviceType.includes(2) ||
                        userBingDeviceType.includes(3))
                  "
                >
                  <ul>
                    <li v-for="(d, index) in listData.trail.list" :key="index" class="row-list">
                      <div class="row-header">
                        <img
                          class="audio"
                          :src="
                            require(isDefaultTheme
                              ? '@/icon/re-new-command/icon_gps.png'
                              : '@/icon/new-common/icon_gps.png')
                          "
                        />
                        <div class="row-title">
                          <span>
                            {{ $t('startS') + ':' + d.startTimestamp }}
                          </span>
                          <span>
                            {{ $t('endS') + ':' + d.endTimestamp }}
                          </span>
                        </div>
                        <img
                          class="important-star"
                          :src="
                            require(isDefaultTheme
                              ? '@/icon/new-command/history/defaultStar.png'
                              : '@/icon/new-command/history/importStar.png')
                          "
                          alt=""
                          v-if="d.importantFlag"
                        />
                      </div>
                      <div class="play-block">
                        <div class="track-hover">
                          <img
                            v-has="'sys:new:command:media:delete'"
                            :title="$t('deleteGPS')"
                            class="imp-trace"
                            src="@/icon/new-command/history/delet.png"
                            @click="_tranceDelete(d.userId, d.sidGroup)"
                          />
                          <img
                            :title="[
                              d.importantFlag
                                ? $t('SetAsNormal') + $t('trajectory')
                                : $t('SetAsImportant') + $t('trajectory'),
                            ]"
                            class="delet-trace"
                            :src="[
                              d.importantFlag
                                ? require('@/icon/new-command/history/track.png')
                                : require('@/icon/new-command/history/picture.png'),
                            ]"
                            @click="_setImpTrack(d.sidGroup, d.userId, !d.importantFlag)"
                          />
                        </div>
                        <span v-if="d.status === 1" class="delete-tag">{{ $t('Deleted') }}</span>
                        <div v-else class="btn-trail" @click="playTrail(listData.trail.list, index)">
                          <img
                            :src="
                              require(isDefaultTheme
                                ? '@/icon/re-new-command/icon_play-mini.png'
                                : '@/icon/new-common/icon_play-mini.png')
                            "
                          />
                          <span>{{ $t('PlayTrack') }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-tab-pane>
                <!-- 音频播放 页签，仅公有云版本并且为执法仪设备展示  -->
                <el-tab-pane
                  v-if="isCloud && mediums.includes(5) && userBingDeviceType.includes(2)"
                  label="音频"
                  class="trail-tab"
                  name="audio"
                >
                  <ul>
                    <li v-for="(d, index) in listData.audio.list" :key="index" class="row-list">
                      <div class="row-header">
                        <img class="audio" src="@/icon/new-common/ic_video.png" />
                        <h5 class="row-title" @click="playAudioIndex = -1">
                          {{ d.logId }}
                        </h5>
                        <span v-if="!d.uploadFlag" class="not-uploaded-tag">
                          未上传
                        </span>
                        <span v-else-if="d.status === 1" class="delete-tag">已删除</span>
                      </div>
                      <audio
                        class="play-audio"
                        v-if="playAudioIndex === index"
                        controls
                        autoplay
                        :src="d.mediaUrl"
                      ></audio>
                      <h5 v-if="playAudioIndex !== index" class="row-time">
                        {{ d.startTimestamp }}
                      </h5>
                      <div class="play-block" v-if="playAudioIndex !== index">
                        <div class="track-hover">
                          <img
                            title="删除音频"
                            class="delet-trace"
                            src="@/icon/new-command/history/delet.png"
                            @click="_mediasDelete(d.logTimestamp, d.type, d.userId)"
                          />
                        </div>
                        <div class="btn-trail" @click="playAudioIndex = index">
                          <img src="@/icon/re-new-command/icon_play-mini.png" />
                          <span>播放音频</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-tab-pane>
                <!-- 设备状态详情 页签 -->
                <el-tab-pane
                  :label="$t('EquipmentStatus')"
                  name="deviceDetail"
                  class="trail-tab"
                  v-if="
                    mediums.includes(6) &&
                      (userBingDeviceType.includes(1) ||
                        userBingDeviceType.includes(2) ||
                        userBingDeviceType.includes(3))
                  "
                >
                  <table
                    class="status_info"
                    :style="{ height: listData.deviceDetail.HM_SYSTEM !== $t('开启') ? '80px' : '' }"
                  >
                    <tr>
                      <th>{{ $t('QueryTime') }}</th>
                      <td colspan="3">
                        <template>
                          {{ lastQueryTime | datetimeShort }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('EquipmentSwitchStatus') }}</th>
                      <td colspan="3">
                        <template>
                          {{ listData.deviceDetail.HM_SYSTEM != $t('开启') ? $t('关机') : $t('开机') }}
                        </template>
                      </td>
                    </tr>
                    <template v-if="listData.deviceDetail.HM_SYSTEM === $t('开启')">
                      <tr>
                        <th>{{ $t('Power') }}</th>
                        <td colspan="3">
                          {{
                            listData.deviceDetail.logBatteryDto
                              ? listData.deviceDetail.logBatteryDto.dumpEnergy + 'mAh'
                              : '-'
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>WiFi</th>
                        <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_WIFI === $t('closeN') }">
                          <template>
                            {{ $t(listData.deviceDetail.HM_WIFI) }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>4G</th>
                        <td
                          colspan="3"
                          :class="{ 'close-color': listData.deviceDetail.HM_MOBILEDATA === $t('closeN') }"
                        >
                          <template> {{ $t(listData.deviceDetail.HM_MOBILEDATA) }} </template>
                        </td>
                      </tr>
                      <tr>
                        <th>GPS/{{ $t('Beidou') }}</th>
                        <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_GPS === $t('closeN') }">
                          <span
                            v-if="listData.deviceDetail.logGpsTraceDataDto && listData.deviceDetail.HM_GPS === $t('开启')"
                            :title="
                              $t('longitude') +
                                ':' +
                                listData.deviceDetail.logGpsTraceDataDto.lng +
                                '，' +
                                $t('latitude') +
                                ':' +
                                listData.deviceDetail.logGpsTraceDataDto.lat
                            "
                          >
                            {{ $t(listData.deviceDetail.HM_GPS) }}
                          </span>
                          <span v-else>
                            {{ $t(listData.deviceDetail.HM_GPS) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('Bluetooth') }}</th>
                        <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_BLUETOOTH === $t('closeN') }">
                          <template>
                            {{ $t(listData.deviceDetail.HM_BLUETOOTH) }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('cameraHead') }}</th>
                        <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_CAMERA === $t('closeN') }">
                          <template>
                            {{ $t(listData.deviceDetail.HM_CAMERA) }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('laser') }}</th>
                        <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_LASER === $t('closeN') }">
                          <template>
                            {{ $t(listData.deviceDetail.HM_LASER) }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('floodlight') }}</th>
                        <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_LEDLIGHT === $t('closeN') }">
                          <template>
                            {{ $t(listData.deviceDetail.HM_LEDLIGHT) }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('temperature') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.deviceDetail.logExtraDataDto && listData.deviceDetail.logExtraDataDto.envTemp
                                ? listData.deviceDetail.logExtraDataDto.envTemp + '℃'
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('pressure') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.deviceDetail.logExtraDataDto && listData.deviceDetail.logExtraDataDto.pressure
                                ? (Number(listData.deviceDetail.logExtraDataDto.pressure) / 10).toFixed(2) + 'kPa'
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                    </template>
                  </table>
                </el-tab-pane>
                <!-- jls轨迹 页签 -->
                <el-tab-pane
                  :label="$t('jlsTrajectory')"
                  name="jlstrail"
                  class="trail-tab"
                  v-if="mediums.includes(7) && userBingDeviceType.includes(0)"
                >
                  <ul>
                    <li v-for="(d, index) in listData.jlstrail.list" :key="index" class="row-list">
                      <div class="row-header">
                        <img class="audio" src="@/icon/new-common/icon_gps.png" />
                        <div class="row-title">
                          <span>
                            {{ $t('startS') + '：' + d.beginTime }}
                          </span>
                          <span>
                            {{ $t('endS') + '：' + d.endTime }}
                          </span>
                        </div>
                        <img
                          class="important-star"
                          src="@/icon/new-command/history/importStar.png"
                          alt=""
                          v-if="d.importantFlag"
                        />
                      </div>
                      <div class="play-block">
                        <span v-if="d.status === 1" class="delete-tag"> {{ $t('Deleted') }}</span>
                        <div v-else class="btn-trail" @click="playTrail(listData.jlstrail.list, index)">
                          <img src="@/icon/re-new-command/icon_play-mini.png" />
                          <span>{{ $t('PlayTrack') }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-tab-pane>
                <!-- jls设备状态详情 页签 -->
                <el-tab-pane
                  :label="$t('jlsEquipmentStatus')"
                  name="jlsDeviceDetail"
                  class="trail-tab"
                  v-if="mediums.includes(8) && userBingDeviceType.includes(0)"
                >
                  <table class="status_info">
                    <tr>
                      <th>{{ $t('time') }}</th>
                      <td colspan="3">
                        <template>
                          {{ listData.jlsDeviceDetail.tempCurrenTime }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('heartRate') }}</th>
                      <td colspan="3">
                        <template>
                          {{
                            listData.jlsDeviceDetail.heartRate
                              ? listData.jlsDeviceDetail.heartRate + $t('heartRateUnit')
                              : '-'
                          }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('BloodOxygen') }}</th>
                      <td colspan="3">
                        <template>
                          {{
                            listData.jlsDeviceDetail.bloodOxygen
                              ? Number(listData.jlsDeviceDetail.bloodOxygen).toFixed(1) + '%'
                              : '-'
                          }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('signalIntensity') }}</th>
                      <td colspan="3">
                        <template>
                          {{
                            listData.jlsDeviceDetail.signNum
                              ? listData.jlsDeviceDetail.signLever + ':' + listData.jlsDeviceDetail.signNum
                              : '-'
                          }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Power') }}</th>
                      <td colspan="3">
                        <template>
                          {{
                            listData.jlsDeviceDetail.freeBattery
                              ? Number(listData.jlsDeviceDetail.freeBattery).toFixed(1) + '%'
                              : '-'
                          }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('pressure') }}</th>
                      <td colspan="3">
                        <template>
                          {{
                            listData.jlsDeviceDetail.altitude
                              ? Number(listData.jlsDeviceDetail.altitude).toFixed(3) + 'kPa'
                              : '-'
                          }}
                        </template>
                      </td>
                    </tr>
                  </table>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
          <!-- 分页组件 -->
          <el-pagination
            v-if="activeName !== 'deviceDetail' && activeName !== 'jlsDeviceDetail' && !imgShow && !videoShow"
            class="pagination"
            @size-change="pageChange"
            @current-change="searchList(activeName)"
            :current-page.sync="listDataQuery[activeName].pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="query.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="this.listData[this.activeName] ? this.listData[this.activeName].total : 0"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </div>
    </el-collapse-transition>
    <MapViewPage
      v-if="showMap"
      :viewPlayTrail="true"
      :trailData="trailData"
      :trailIndex="trailIndex"
      :currentItem="historyData"
      :query="query"
      :total="total"
      :pageNum="pageNum"
      :showMap.sync="showMap"
    ></MapViewPage>
  </div>
</template>

<script>
import { trailGroup, selectRecord } from '@/api/monitor'
import {
  listMediasTag,
  downloadPic,
  mediasDelete,
  tranceDelete,
  rtcDelete,
  setImpImg,
  setImpTrack,
  mediaOperations,
} from '@/api/log/mediaTag'
import { findUserBingDeviceLog, gethelmet } from '@/api/helmetManage'
import { listAudio, listAllGps, listAllPhoto, listRecording } from '@/api/log/log'
import { getLogStatus } from '@/api/log/status'
import { isImportantFlag } from '@/api/log/video'
import { getLogin } from '@/api/login'
import { success, getSession, nextDate, delSession, nowDateTime } from '@/api/common'
import { loginStorage } from '@/common/loginStorage'
import { loadVideoHitory } from '@/util/historyVideo'
import { deepClone } from '@/util/common'
import { download } from '@/util/file'
import { formatDate, formatTime, nowDate, now, beforeMonthDate } from '@/util/date'
import { mapGetters } from 'vuex'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

import HistoryVideo from '@/components/new-historyVideo/Index.vue'
import MapViewPage from '@/components/external-history/MapView'

import md5 from 'js-md5'

var errobj = {}
export default {
  props: {
    helmetType: {
      type: Number,
    },
  },
  data() {
    return {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      allowDrag: true,
      speed: 1.0,
      // 公用查询参数
      query: {
        userId: '',
        helmetId: '',
        logTimestampBegin: beforeMonthDate(),
        logTimestampEnd: nowDate(),
        pageSize: 10,
      },
      // 页签独立查询参数
      listDataQuery: {
        video: { pageNum: 1 },
        importantVideo: { pageNum: 1 },
        Recording: { pageNum: 1, importantFlag: false },
        audio: { pageNum: 1 },
        trail: { pageNum: 1 },
        photo: { pageNum: 1 },
        jlstrail: { pageNum: 1 },
        deviceDetail: {
          pageNum: 1,
          gpsType: 1,
          logTimestampEnd: now(),
        },
        jlsDeviceDetail: {
          logTimestampEnd: nowDate(),
        },
      },
      lastQueryTime: now(),
      // 页签响应数据
      listData: {
        video: {
          total: 0,
          list: [],
        },
        importantVideo: {
          total: 0,
          list: [],
        },
        Recording: { total: 0, list: [] },
        audio: {
          total: 0,
          list: [],
        },
        trail: {
          total: 0,
          list: [],
        },
        photo: {
          total: 0,
          list: [],
        },
        deviceDetail: {},
        jlstrail: {
          total: 0,
          list: [],
        },
        jlsDeviceDetail: {},
      },
      // 默认打开页签：图片
      activeName: 'video',
      // 播放音频索引
      playAudioIndex: -1,
      // 播放器开关
      videoShow: false,
      recordingVideoShow: false,
      // 当前播放视频列表
      playVideoData: [],
      // 当前选中的video index
      index: null,
      tabType: '',
      coverSrc: require('@/icon/monitor/coverPlaceDark.png'),
      theme: localStorage.getItem('theme'),
      // 用户绑定设备历史记录
      userBingDevice: [],
      userBingDeviceType: [],
      this_helmetType: this.helmetType,
      // 播放轨迹显示地图
      showMap: false,
      total: 0,
      pageNum: 1,
      previewMiddleImg: {
        name: this.$t('titleF'),
        time: '2000-01-01 00:00:00',
        image: '',
      },
      // 是否显示 预览图片
      imgShow: false,
      mediums: '',
      inenerHeight: window.innerWidth,
    }
  },
  computed: {
    ...mapGetters(['isCloud', 'isDefaultTheme','isOnlySupportPosition']),
    // 计算图片预览组件的预览图数组
    previewImgList() {
      return this.listData.photo.list.map(i => {
        return i.mediaUrl
      })
    },
    item() {
      return this.$store.state.currentHelmetData
    },
    //jlsSignInfo() {
    //  return this.$store.state.jlsSignInfo
    //},
  },
  components: {
    HistoryVideo,
    VueDraggableResizable,
    MapViewPage,
  },
  mounted() {
    this.username = this.getQueryVariable('appKey')
    let secretKey = this.getQueryVariable('secretKey')
    this.mediums = this.getQueryVariable('medium')
    this.timestamp = nowDateTime()
    let passKey = secretKey + '.' + this.username + '.' + this.timestamp + '.' + secretKey
    this.password = md5(passKey)

    // 判断地址上的 参数是否有ID
    let helmetId = this.getQueryVariable('id')
    this.userId = null
    if (this.getQueryVariable('userid')) {
      this.userId = this.getQueryVariable('userid')
    }
    if (!helmetId) {
      console.log('未传入安全帽id')
      return
    }
    if (!this.username || !secretKey) {
      delSession('access_token')
      delSession('expireTime')
      delSession('HWSecurity_access_token')
      delSession('userId')
      sessionStorage.removeItem('featureCode')
      sessionStorage.removeItem('isAdmin')
    }
    this.device = {
      serialNumber: helmetId,
      userId: this.userId,
      userName: '',
    }
    this.login()
    window.onresize = () => {
      return (() => {
        this.inenerHeight = window.innerWidth
      })()
    }
  },
  methods: {
    // 获取地址栏参数
    getQueryVariable(name) {
      try {
        var url = window.location.href
        if (url.indexOf('?') === -1) {
          return ''
        }
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = url.split('?')[1].match(reg)
        if (r !== null) {
          return r[2]
        }
        // 如果此处只写return,则返回的是undefined //NOSONAR
        return ''
      } catch (e) {
        // 如果此处只写return,则返回的是undefined //NOSONAR
        return ''
      }
    },
    // 请求登录接口、登录成功后连接websocket服务
    login() {
      let params = {
        data: {
          username: this.username,
          password: this.password,
          grant_type: 'password',
          auth_type: 'ak_sk',
          timestamp: this.timestamp,
        },
      }
      getLogin(params).then(val => {
        let state = val.state
        let res = val
        if (state === 0) {
          this.getDeviceInfo()
          this.loginErrorHint = ''
          this.$store.dispatch('alterName', res.username)
          // 参数储存
          loginStorage(res)

          if (localStorage.getItem('theme') === null) {
            localStorage.setItem('theme', 'default')
          }
        } else {
          console.log('登录失败')
          this.$notify({
            title: '提示',
            message: ' 密钥无效，请重新获取',
            duration: 0,
          })
        }
      })
    },
    // 获取列表
    getDeviceInfo() {
      let params = {
        serialNumber: this.device.serialNumber,
        specModel: '',
        status: '',
        binded: '',
        pageNum: 1,
        pageSize: 10,
        specType: '',
      }
      gethelmet(params).then(res => {
        if (res.state === 0) {
          let helmetUser = res.data.list
          if (helmetUser && helmetUser[0]) {
            if (helmetUser[0].onlineStatus === 0) {
              // 提示设备不在线
              this.showErr = true
            }
            this.device = helmetUser[0]
            this.historyData = helmetUser[0]
            this.handleData()
            if (helmetUser[0].userId) {
              // 用地址上的userid 与获取数据的id比较
              if (this.userId !== '' && this.userId) {
                if (this.device.userId !== helmetUser[0].userId) {
                  this.$notify({
                    title: '提示',
                    message: '设备序列号与用户ID不匹配',
                    duration: 0,
                    position: 'bottom-right',
                  })
                }
              } else {
                this.userId = helmetUser[0].userId
              }
            } else {
              this.$notify({
                title: '提示',
                message: '该设备未绑定用户',
                duration: 0,
                position: 'bottom-right',
              })
              return
            }
            this.device.userName = helmetUser[0].userName
          } else {
            this.$notify({
              title: '提示',
              message: '无该设备序列号',
              duration: 0,
            })
            return
          }
        }
      })
    },
    handleData() {
      // 首次渲染没有触发watch，手动触发
      this.query.helmetId = this.historyData.serialNumber
      this.query.userId = this.historyData.userId
      if (this.historyData.serialNumber) {
        console.log('this.historyData.serialNumber', this.historyData)
        this.userBingDeviceType.push(this.historyData.specType)
        if (this.historyData.specType === 0 || this.historyData.specType === 4) {
          this.activeName = 'jlstrail'
        } else {
          this.activeName = 'photo'
        }
        this.searchList()
      }
    },
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function(x, y) {
      console.log(x, y)
      this.x = x
      this.y = y
    },
    triggerPack() {
      this.recordingVideoShow = false
      this.videoShow = false
    },
    targetTab(type) {
      this.recordingVideoShow = false
      this.videoShow = false
      this.activeName = type
      this.searchList(type)
    },
    // 页面改变需要查询，套一层是为了防止默认参数传递
    pageChange() {
      if (this.activeName !== 'Recording') {
        this.recordingVideoShow = false
      } else if (this.activeName !== 'video') {
        this.videoShow = false
      }
      this.listDataQuery[this.activeName]['pageNum'] = 1
      this.videoShow = false
      this.imgShow = false
      this.searchList()
    },
    // 查询列表数据
    searchList(activeName) {
      // 如果不指定，查询当前tab数据
      if (!activeName) {
        activeName = this.activeName
      }
      if (!this.item.serialNumber) {
        this.item.serialNumber = this.item.deviceName
      }
      // 当绑定一个用户时才会进行查询
      this.listData[activeName]['list'] = []
      console.log('searchList', activeName, this.query.userId)
      if (this.query.userId) {
        // 拼接查询条件
        let query = Object.assign(deepClone(this.query), this.listDataQuery[activeName])
        if (query.logTimestampBegin) {
          query.logTimestampBegin = formatTime(query.logTimestampBegin)
        }
        if (query.logTimestampEnd && activeName !== 'deviceDetail') {
          // 除设备详情信息外 所有页签结束时间设置为每天最后一秒
          query.logTimestampEnd = formatDate(query.logTimestampEnd) + ' 23:59:59'
        }
        this.tabType = ''
        switch (activeName) {
          case 'video':
          case 'importantVideo':
            this.index = null
            query.groupActual = 1
            query.userId = ''
            listMediasTag(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'Recording':
            let param = {
              userId: '',
              helmetId: this.query.helmetId,
              limit: 10,
              offset: (this.listDataQuery[activeName].pageNum - 1) * query.pageSize,
              logTimestampBegin: query.logTimestampBegin,
              logTimestampEnd: query.logTimestampEnd,
            }
            this.tabType = 'Recording'
            listRecording(param).then(res => {
              if (res.state === 0) {
                this.listData[activeName].list = res.data.mediaList
                this.handleVideo(activeName, res.data.mediaList)
                if (this.listData[activeName].list && this.listData[activeName].list.length > 0) {
                  for (let item of this.listData[activeName].list) {
                    if (item.mediaUrlHttps) {
                      item.mediaUrl = item.mediaUrlHttps
                    }
                  }
                }
                this.listData[activeName].total = res.data.totalCount
              }
            })
            // console.log(this.listData, 'this.listData')
            break
          case 'audio':
            query.specType = 2
            query.userId = ''
            listAudio(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'trail':
            // query.userId = ''
            listAllGps(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'photo':
            query.userId = ''
            listAllPhoto(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'deviceDetail':
            // 删除拷贝的开始时间属性
            query.userId = this.historyData.userId
            query.helmetId = this.query.helmetId
            delete query['logTimestampBegin']
            // 记录最近一次查询时间
            this.lastQueryTime = query.logTimestampEnd
            getLogStatus(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'jlstrail':
            let trailGroupParam = {
              // userId: this.historyData.userId,
              userId: '',
              deviceName: this.query.deviceName,
              beginTime: formatDate(query.logTimestampBegin),
              endTime: formatDate(query.logTimestampEnd),
              pageNum: query.pageNum,
              pageSize: query.pageSize,
            }
            trailGroup(trailGroupParam).then(res => {
              this.listData[activeName] = res.data
            })
            break
          case 'jlsDeviceDetail':
            let helmetId = this.query.helmetId
            if (!helmetId) {
              let jlsHelmet = this.userBingDevice.filter(h => h.specType === 0)
              if (jlsHelmet.length > 0) {
                helmetId = jlsHelmet[0].deviceSN
              }
            }
            let jlsDeviceDetailParam = {
              // userId: this.historyData.userId,
              userId: '',
              deviceName: helmetId,
              startTime: nowDate().replace(/-/g, '/'),
              endTime: nextDate(),
              limit: 1,
              healthLimit: 1,
            }
            selectRecord(jlsDeviceDetailParam).then(res => {
              if (res.state === 0) {
                let baseStationPage = res.data.baseStationPage
                let deviceStatusPage = res.data.deviceStatusPage
                let healthStatusPage = res.data.healthStatusPage
                let locationPage = res.data.locationPage
                let jlsSignInfo = {}
                if (baseStationPage && baseStationPage[0]) {
                  jlsSignInfo.signNum = baseStationPage[0].rss
                  if (jlsSignInfo.signNum > -75) {
                    jlsSignInfo.signLever = this.$t('strong')
                  } else if (jlsSignInfo.signNum < -85) {
                    jlsSignInfo.signLever = this.$t('weak')
                  } else {
                    jlsSignInfo.signLever = this.$t('centre')
                  }
                }
                if (healthStatusPage && healthStatusPage.recordList && healthStatusPage.recordList[0]) {
                  jlsSignInfo.tempCurrenTime = healthStatusPage.recordList[0].timestamp.split('T')[0]
                  jlsSignInfo.bloodOxygen = healthStatusPage.recordList[0].bloodOxygen
                  jlsSignInfo.heartRate = healthStatusPage.recordList[0].heartRate
                }
                if (deviceStatusPage && deviceStatusPage[0]) {
                  jlsSignInfo.tempCurrenTime = !jlsSignInfo.tempCurrenTime
                    ? deviceStatusPage[0].timestamp.split('T')[0]
                    : jlsSignInfo.tempCurrenTime
                  jlsSignInfo.freeBattery = deviceStatusPage[0].freeBattery
                }
                if (locationPage && locationPage[0]) {
                  if (locationPage[0]) {
                    jlsSignInfo.altitude = locationPage[0].pressure / 1000
                  }
                }
                this.listData[activeName].list = {}
                this.listData[activeName] = jlsSignInfo
              }
            })
        }
      }
    },
    setData(data, activeName) {
      if (data.state === 0) {
        // 设备状态详情状态抽取赋值
        this.listData[activeName].list = []
        if (activeName === 'deviceDetail' && data.value.moduleStatusDtos) {
          data.value.moduleStatusDtos.forEach(item => {
            data.value[item.propertyKey] = item.eventFmt
          })
        }
        if (activeName === 'video') {
          this.handleVideo(activeName, data.value.list)
        }
        this.listData[activeName] = data.value
      }
    },
    handleVideo(activeName, data) {
      let history = loadVideoHitory(this.item)
      console.log(history)
      if (history.length > 0 && data.length > 0) {
        for (let item of history) {
          let index = data.findIndex(i => {
            return i.name === item.name
          })
          console.log(index)
          if (index >= 0) {
            data[index].Played = true
          }
        }
      }
      this.listData[activeName].list = data
    },
    // 播放视频
    playVideo(index, isRecording = false) {
      if (isRecording) {
        this.recordingVideoShow = true
        this.videoShow = false
        // 深拷贝赋值
        this.playVideoData = JSON.parse(JSON.stringify(this.listData.Recording.list))
      } else {
        this.recordingVideoShow = false
        this.videoShow = true
        // 深拷贝赋值
        this.playVideoData = JSON.parse(JSON.stringify(this.listData.video.list))
      }
      this.index = index
    },
    // 播放轨迹
    playTrail(data, index) {
      // 存储页码、总页数
      this.pageNum = this.listDataQuery[this.activeName].pageNum || 1
      // 总页数
      this.total = this.listData[this.activeName].total
        ? Math.ceil(this.listData[this.activeName].total / this.query.pageSize)
        : 0
      this.showMap = true
      this.trailData = data
      this.trailIndex = index
    },
    // 下载文件
    download(src) {
      download(src)
    },
    // 图片加载失败后触发error的函数：
    srcerr(item, index) {
      // console.log(item, index)
      // 判断该图片的链接是否以err开头,第一次没触发error。
      if (/^err/.test(item)) {
        // 把截掉err的链接重新赋值回imgList，imgList更新又赋值链接给图片，到目前为止该图片已经重新请求了一次正确的地址，正常情况下图片会成功渲染
        this.listData.photo.list[index].mediaUrl = item.slice(3)
        this.$set(this.listData.photo.list, index, this.listData.photo.list[index])
      } else {
        // 判断data里定义好的errobj对象里是否存在该条链接，不存在则保存在errobj里对应的值为1。
        if (!errobj[index]) {
          errobj[index] = 1
        } else {
          // 最多3次请求的机会，超过3次链接不会拼接err，失败的error就不会再触发
          if (errobj[index] > 2) {
            return
          } else {
            errobj[index] += 1
          }
        }
        this.listData.photo.list[index].mediaUrl = 'err' + item
        this.$set(this.listData.photo.list, index, this.listData.photo.list[index])
      }
    },
    srcerrVideo(item, index) {
      // 判断该图片的链接是否以err开头,第一次没触发error。
      if (/^err/.test(item)) {
        // 把截掉err的链接重新赋值回imgList，imgList更新又赋值链接给图片，到目前为止该图片已经重新请求了一次正确的地址，正常情况下图片会成功渲染
        this.listData.video.list[index].preMediaUrl = item.slice(3)
        this.$set(this.listData.video.list, index, this.listData.video.list[index])
      } else {
        // 判断data里定义好的errobj对象里是否存在该条链接，不存在则保存在errobj里对应的值为1。
        if (!errobj[index]) {
          errobj[index] = 1
        } else {
          // 最多3次请求的机会，超过3次链接不会拼接err，失败的error就不会再触发
          if (errobj[index] > 2) {
            return
          } else {
            errobj[index] += 1
          }
        }
        this.listData.video.list[index].preMediaUrl = 'err' + item
        this.$set(this.listData.video.list, index, this.listData.video.list[index])
      }
    },
    //点击图片
    previewImgClick(item, index, imageList) {
      console.log(item, index, imageList)
      this.imgShow = true
      this.previewMiddleImg.image = item.mediaUrl
      this.previewMiddleImg.name = item.location
      this.previewMiddleImg.time = item.logTimestamp
    },
    // 下载图片
    downloadImg(path, name, url, media) {
      if (media && media.groupVideoList && media.groupVideoList.length > 0) {
        this.$confirm(this.$t('downLoadThisFile1') + media.groupVideoList.length + this.$t('downLoadThisFile2'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(async () => {
          for (let item of media.groupVideoList) {
            if (item.mediaUrl) {
              await downloadPic(item.path, item.name).then(res => {
                this.downImg(item.name, res)
              })
            }
          }
        })
      } else if (url) {
        downloadPic(path, name).then(res => {
          this.downImg(name, res)
        })
      }
    },
    // 媒体文件删除
    _mediasDelete(logTimestamp, type, userId) {
      if (logTimestamp) {
        this.$confirm(this.$t('deleteThisFile'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          mediasDelete(logTimestamp, type, userId).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.searchList()
              if (this.activeName === 'photo') {
                this.handleDelectOperat(103)
              } else if (this.activeName === 'audio') {
                this.handleDelectOperat(100)
              } else if (this.activeName === 'video') {
                this.handleDelectOperat(105)
              } else if (this.activeName === 'importantVideo') {
                this.handleDelectOperat(102)
              }
            }
          })
        })
      }
    },
    // 设置重要图片
    _setImpImg(logTimestamp, userId, importantFlag) {
      let param = {
        importantFlag: importantFlag,
        logTimestamp: logTimestamp,
        type: 2,
        userId: userId,
      }
      setImpImg(param).then(res => {
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.searchList()
        }
      })
    },
    // 设置重要视频
    _setImpVideo(logTimestamp, userId, importantFlag) {
      let param = {
        importantFlag: importantFlag,
        logTimestamp: logTimestamp,
        type: 1,
        userId: userId,
      }
      isImportantFlag(param).then(res => {
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.searchList()
        }
      })
    },
    // 设置重要轨迹
    _setImpTrack(sidGroup, userId, importantFlag) {
      let param = {
        importantFlag: importantFlag,
        sidGroup: sidGroup,
        userId: userId,
      }
      setImpTrack(param).then(res => {
        // console.log(res)
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.searchList()
        }
      })
    },
    // 轨迹删除
    _tranceDelete(userId, sidGroup) {
      if (userId) {
        this.$confirm(this.$t('deleteThisFile'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          tranceDelete(userId, sidGroup).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.searchList()
              this.handleDelectOperat(101)
            }
          })
        })
      }
    },
    // rtc 视频删除
    _rtcDelete(fileId) {
      if (fileId) {
        this.$confirm(this.$t('deleteThisFile'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          rtcDelete(fileId).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.searchList()
              this.handleDelectOperat(104)
            }
          })
        })
      }
    },
    // 删除媒体数据记录操作
    handleDelectOperat(type) {
      let param = [
        {
          childOperation: type,
          event: -1,
          logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
          loginUserName: getSession('username'),
          operation: '删除媒体数据',
          remoteHelmetId: this.item.deviceName,
          remoteUserId: this.item.userId,
          remoteUserName: this.item.userName,
        },
      ]
      mediaOperations(param)
    },
    // 下载图片
    downImg(file_name, content) {
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, file_name)
      }
      // for Non-IE (chrome, firefox etc.)
      else {
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = file_name
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    cancleVideoShow() {
      this.videoShow = false
      this.recordingVideoShow = false
      this.searchList()
    },
  },
  watch: {
    historyData: {
      handler(val) {
        this.query.userId = val.userId
        this.query.helmetId = val.serialNumber
        // this.userBingDeviceType = []
        // 关闭视频播放窗口
        this.recordingVideoShow = false
        this.videoShow = false
        if (val.serialNumber) {
          this.userBingDeviceType.push(val.specType)
          if (this.this_helmetType !== val.specType) {
            if (val.specType === 0 || val.specType === 0) {
              this.activeName = 'jlstrail'
            } else {
              this.activeName = 'photo'
            }
          }
          this.this_helmetType = val.specType
          this.searchList()
        }
      },
      deep: true,
    },
    helmetType: {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.activeName = 'jlstrail'
        } else {
          if (this.activeName === 'jlstrail' || this.activeName === 'jlsDeviceDetail') {
            this.activeName = 'photo'
          }
        }
        this.this_helmetType = val
      },
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/common.styl'
.close-color
  color #989898
#amplifyVideo
  pointer-events: auto
  background #fff
  position fixed
  left: 30%
  top: 20%
  width 520px
  // height 400px
  padding 4px
  border: 1px solid rgba(0, 222, 255, 0.5)
  z-index: 9999
.contain
  position relative
  width 99%
  height 99%
  border: 1px solid #0E65DD
  border-radius: 4px;
  margin: 0 auto;
  .shrink
    width 100%
    height 100%
    background #fff
    position: absolute;
    transition: width 0.5s
    border-radius 4px
    .title
      font-size: 20px;
      font-weight: bold;
      color: #0E65DD;
      text-align center
      line-height: 46px;
      background-image: linear-gradient(to right, rgb(212, 238, 255), rgb(244, 251, 255));
    .icon-list
      display flex
      flex-direction: column;
      align-items: center
      justify-content: space-around
      height: 93%;
      .icon-block
        display flex
        flex-direction: column;
        align-items: center
        // .icon
        //   width 54px
        //   height 55px
      .line
        width 75%
        height: 1px;
        background: #D1DAE7;
        opacity: 0.5;
      .none
        visibility hidden
    .jls_icons
      justify-content start
      .icon-block
        height 180px
        justify-content center
    .extend-up
      height 63px
      width 24px
      bg-image('~@/icon/re-new-command/history/shrink.png')
      position absolute
      bottom 0
      left -23px
      cursor pointer
      span
        font-size: 12px
        color #0E65DD
        position absolute
        top: 13px;
        left: 6px;
      i
        width 10px
        height 10px
        bg-image('~@/icon/re-new-command/arrow-left.png')

        display: inline-block;
        position: absolute;
        bottom: 3px;
        left: 7px;
  .extend
    width: 99%;
    height: 94%;
    background #fff
    border-radius: 4px;
    .title
      font-size: 18px;
      font-weight: bold;
      color: #0E65DD;
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% - 40px);
      padding-left: 40px;
      line-height: 46px;
      background-image: linear-gradient(to right, rgb(212, 238, 255), rgb(244, 251, 255));
      border-radius: 4px;
    .exVideo
      background #fff
      width 98%
      height 98%
      border: 1px solid rgba(0, 222, 255, 0.5);
      z-index: 999
      margin: 0 auto
      .exVideoTitle
        padding-bottom: 10px;
        color #222
        display flex
        justify-content: space-between;
        align-items: center;
        span
          font-size: 18px;
          font-weight: bold;
    .reRxVideo
      // bg-image('~@/icon/new-command/history/opacity-bg.png')
      background #fff
      position fixed
      // left: 30%
      // top: 20%
      // width 30%
      // height: 48%
      // padding 10px
      border: 1px solid rgba(0, 222, 255, 0.5);
      z-index: 999
      .exVideoTitle
        padding-bottom: 10px;
        color #222
        display flex
        justify-content: space-between;
        align-items: center;
        span
          font-size: 18px;
          font-weight: bold;
    .main
      margin: 50px 10px 10px 10px;
      height: calc( 100% - 70px );
      >>>.el-tab-pane
        height 99%
      .trail-tab
        width 50%
      .preview
        position: relative;
        width: 100%;
        height: 100%;
        .img-preview
          width: 100%;
          height: calc(100% - 80px);
          margin: 10px auto;
          .el-image
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
        .img-title
          display: flex;
          .name
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        .back-icon {
          cursor: pointer;
          margin-left: 10px;
          width: 16px;/*no*/
          height: 16px;/*no*/
          display: inline-block;
        }

        .back-light {
          bg-image('~@/icon/ic_back.png');
        }

        .back-dark {
          bg-image('~@/icon/ic_back_new.png');
        }
      ul
        margin-top 10px
        height 100%
        overflow-y auto
        li
          width 260px;/*no*/
          height 200px;/*no*/
          position relative
          margin-left 20px
          margin-top 20px
          float left
          cursor default
          .pic_contrl
            width 100%
            position: absolute;
            bottom: 5px;
            left: 1px;
            background rgba(0, 0, 0,0.6)
            .video-time-pic
              width: 100%;
              height: 42px;/*no*/
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size 12px/*no*/
              font-weight 400
              color #fff
              line-height: 20px;/*no*/
              overflow: hidden
              text-overflow: ellipsis
              white-space: nowrap
              span
                margin-left 9px/*no*/
                font-size 12px/*no*/
          &:hover .download-icon
            display block
          &:hover .download-icon-delete
            display block
          &:hover .setPicImp-icon, &:hover .setNormalImp-icon
            display block
          &:hover .video-time
            // width calc(100% - 45px)
            // overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .box
            width 100%
            height 100%
            border-radius 4px
            border: 1px solid #00A0E9;
            .played
              position: absolute
              top 1px
              left 1px
              color var(--tree-black)
              background var(--new-tab-bg)
              width: fit-content
              height 16px
              border-radius 4px
              font-size 12px
              padding 5px
              z-index 9
            .important-star
              position: absolute
              top 1px
              right 1px
            .pic
              width 100%
              height 100%
              cursor pointer
              border-radius 4px
              object-fit fill
            div
              height 100%
              width 100%
              background #E4EAF2
            div.delete
              background #FFF6F6
            video
              width 100%
              height 100%
              cursor pointer
          .video-name
            font-size 14px
            font-weight 400
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
          .pic-icon
            width: 16px;/*no*/
            height: 16px;/*no*/
          .download-icon
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/download.png')
          .setPicImp-icon
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/picture.png')
          .setNormalImp-icon
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/track.png')
          .download-icon-delete
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/delet.png')
          .video-time
            width: 100%;
            height: 29px;
            font-size 14px
            font-weight 400
            color #fff
            line-height: 29px;
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            position: absolute;
            bottom: 20px;
            left: 1px;
            background rgba(0, 0, 0, 0.6)
            span
              margin-left 9px
          .upper
            position absolute
            top 40%
            left 50%
            transform translate(-50%, -60%)
            width 36px
            height 36px
          .place-img
            width 100%
            height 100%
          .upper-text
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -35%)
            font-size 14px
            font-weight 400
            color #4ABE7B
          .delete .upper-text
            color #B41616
          .center
            position absolute
            top 40%
            left 50%
            transform translate(-50%, -50%)
            width 40px
            heigth 40px
            cursor: pointer
            .video-delete
              position absolute
              bottom 18px
              right 23px
              cursor pointer
            .download
              position absolute
              bottom 18px
              right 0
              cursor pointer
        // 一列布局样式
        .row-list
          height 110px;/*no*/
          width 90%
          margin 0 5%
          display flex
          justify-content space-between
          align-items center
          border-bottom 1px solid rgba(220, 223, 230, 1);
          audio
            height 34px
          .important-star
            margin-right 10px
          .row-header
            display flex
            align-items center
            .audio
              width 60px;/*no*/
              height 60px;/*no*/
              margin-right 10px;
            .row-title
              display flex
              font-size 14px
              font-weight 400
              margin-right 20px
              color #333
              flex-direction: column;
              cursor: pointer;
              // min-width: 255px;
          .play-block
            .track-hover
              display none
            .btn-trail
              display flex
              justify-content space-evenly
              align-items center
              width 90px; /* no */
              height 30px;/* no */
              background var(--history-btn-trail-bg)
              border var(--history-btn-trail-border)
              border-radius 4px
              cursor pointer
              color #16326F
            .imp-trace
              cursor pointer
              float right
              // display none
            .delet-trace
              padding-right 7px
              margin-bottom 10px
              cursor pointer
              float right
              // display none
            .delete-tag
              width 50px
              height 24px
              line-height 24px
              text-align center
              background #B41616
              border-radius 4px 0px 4px 0px
              color #FFFFFF
              font-size 12px
            .not-uploaded-tag
              width 50px
              height 24px
              line-height 24px
              text-align center
              background #4ABE7B
              border-radius 4px 0px 4px 0px
              color #FFFFFF
              font-size 12px
          &:hover .track-hover
            display block
          .row-time
            font-size 12px
            font-weight 400
            color #999999
          .download
            opacity 1
            bottom 22px
    .view-info
      .deviceDetail-class
        /deep/ .el-date-editor
          width 178px !important;/*no*/
          // border: 1px solid;
      .deviceDetail1-class
        /deep/ .el-date-editor
          width 178px !important;/*no*/
          // border: 1px solid;
      .deviceDetail2-class
        /deep/ .el-input
          width 185px !important
          // border: 1px solid;
      .status_info
        margin-top 10px
      >>>.el-row
        height: calc(100% - 120px );
        .el-col-24
          height: 100%;
          .el-tabs
            height: 100%;
            .el-tabs__content
              height: calc(100% - 40px);
    table
      border-collapse collapse
      border-spacing 0
      width 100%
      height 520px
      text-align center
    td
      width 75%
    th
      font-size 14px
      font-weight 400
    .pagination
      position: absolute;
      bottom: 10px;
      right: 5px;
      >>>.el-pager li
        background #fff!important
        color: #333;
      >>>.el-pager li.active
        color: #409EFF
    .record-page
      width 160px
      height 20px
      text-align center
      font-size 14px
      line-height 20px
      margin 10px auto 0
    .pack-up
      height 63px
      width 24px
      bg-image('~@/icon/re-new-command/history/shrink.png')
      position absolute
      bottom 0
      left: -23px;
      cursor pointer
      span
        font-size: 12px
        color #0E65DD
        position absolute
        top: 13px;
        left: 6px;
      i
        width 10px
        height 10px
        bg-image('~@/icon/re-new-command/history/arrow-right.png')
        display: inline-block;
        position: absolute;
        bottom: 3px;
        left: 7px;
/deep/ .el-button
  height 30px;/* no */
  padding 7px 15px!important;/* no */

/deep/.el-form-item
  margin-bottom: 14px !important;
/deep/ .el-image__placeholder
  bg-image-full('~@/icon/monitor/coverPlaceDark.png')
// 深色模式样式覆盖
.theme-dark
  #amplifyVideo
    background none
    bg-image('~@/icon/new-command/history/opacity-bg.png')
    .exVideoTitle
      color #fff
  .contain
   .shrink
    background #063184
    .title
      color #00E4FF
      bg-image('~@/icon/new-command/history/shrink-bg-m.png')
    .extend-up
      bg-image('~@/icon/re-new-command/history/shrink-m.png')
      span
        color #00E4FF
      i
        bg-image('~@/icon/re-new-command/arrow-left-m.png')
   .extend
      background #183D94
      .main
        ul
          .row-list
            .row-header
              .row-title
                color #fff
    .main
      .pic_contrl
        .setNormalImp-icon
          bg-image('~@/icon/new-command/history/track-m.png')

        .setPicImp-icon
          bg-image('~@/icon/new-command/history/picture-m.png')

        .download-icon
          bg-image('~@/icon/new-command/history/download-m.png')

        .download-icon-delete
          bg-image('~@/icon/new-command/history/delet-m.png')

    .title
      bg-image('~@/icon/new-command/history/expand-bg-m.png')
      color #00E4FF
    .pack-up
      bg-image('~@/icon/re-new-command/arrow-right-bg-m.png')
      span
        color #00E4FF
      i
        bg-image('~@/icon/re-new-command/arrow-right-m.png')
    .view-info
      /deep/.el-form-item__label
        color #fff

      .pagination
        >>>.el-pager li
          background #041D5D!important
          color: #fff;
        >>>.el-pager li.active
          color: #409EFF
</style>
